import { Notifications } from "../notifications";
export class EditInvoice {
    constructor(form) {
        this.form = form;
        form
            .querySelector("#add-line")
            .addEventListener("click", () => this.addLine());
        this.addRemoveLineListener(this.form);
        form.addEventListener("submit", (ev) => {
            let correct = true;
            form.querySelectorAll("input").forEach((input) => {
                const isSumarizable = input.dataset.isSumarizable === "1";
                if (isSumarizable) {
                    const { value } = input;
                    const floatNumberRegex = /^-?\d*\.?\d+$/;
                    if (floatNumberRegex.test(value) === false) {
                        correct = false;
                        Notifications.error("Los campos que son sumarizables sólo pueden contener números enteros o decimales con un punto como separador.");
                    }
                }
                if (!correct) {
                    ev.preventDefault();
                }
            });
        });
    }
    addRemoveLineListener(f) {
        f.querySelectorAll(".js-remove-line").forEach((button) => {
            button.addEventListener("click", (ev) => this.removeLine(ev.target));
        });
    }
    addLine() {
        const lastLine = document.querySelector(".js-line:last-of-type");
        const newLine = lastLine.cloneNode(true);
        const newLineInputs = newLine.querySelectorAll("input");
        newLineInputs.forEach((input) => {
            input.value = "";
        });
        this.addRemoveLineListener(newLine);
        lastLine.after(newLine);
    }
    static init() {
        const form = document.getElementById("edit_invoice");
        if (!form) {
            return;
        }
        new EditInvoice(form);
    }
    removeLine(target) {
        const line = target.closest(".js-line");
        if (line) {
            line.remove();
        }
    }
}
